import { httpClient } from "./httpClient"
import { API_CONFIG } from "@/infrastructure/config/apiConfig"
import type { LoginRequest, LoginResponse, RefreshTokenApiResponse, RefreshTokenResponse, LoginData } from "@/domain/interfaces/auth"
import type { ApiResponse } from "@/domain/interfaces/api"

export class AuthApi {
  static async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await httpClient.post<LoginData>(API_CONFIG.ENDPOINTS.AUTH.LOGIN, credentials, {
      credentials: "include",
    })

    return response as LoginResponse
  }

  static async confirmOtp(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await httpClient.post<LoginData>(API_CONFIG.ENDPOINTS.AUTH.CONFIRM_OTP, credentials, {
      credentials: "include",
    })

    return response as LoginResponse
  }

  static async forgetPassword(username: string): Promise<LoginResponse> {
    const response = await httpClient.post<LoginData>(API_CONFIG.ENDPOINTS.AUTH.FORGET_PASSWORD, username)

    return response as LoginResponse
  }

  static async refreshToken(): Promise<RefreshTokenApiResponse> {
      const response = await httpClient.post<RefreshTokenResponse>(
        API_CONFIG.ENDPOINTS.AUTH.REFRESH,
        {},
        { credentials: "include" },
      )

      return response as RefreshTokenApiResponse
  }

  static async resetPassword(newPassword: string): Promise<ApiResponse> {
    const response = await httpClient.post<void>(API_CONFIG.ENDPOINTS.AUTH.RESET_PASSWORD, { newPassword }, { credentials: "include" })

    return response
  }

  static async logout(): Promise<ApiResponse<void>> {
    const response = await httpClient.post<void>(API_CONFIG.ENDPOINTS.AUTH.LOGOUT, {}, { credentials: "include" })

    return response
  }
}
